const applicantOrganicCertificationHistoryQuestionnaire = {
    "title": "申請者有機驗證歷史",
    "sections" : [
        {
            "subject": "申請者有機驗證歷史",
            "questions": [
                {
                    "description": "您是否擁有一份現行的【有機標準】?",
                    "type": "scq",
                    "options": ["是", "否"]
                },
                {
                    "description": "請列出先前或現在申請的有機驗證機構名稱、申請年份、標準和驗證結果。",
                    "type": "oeq",
                    "format": {
                        "multiple": true,
                        "fields": ["標準", "驗證機構", "年份", "結果"]
                    }
                },
                {
                    "description": "您是否曾被任何驗證機構駁回、暫時終止或撤銷驗證，或曾收到不符合性通知?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題, 如「是」，請說明原因及該驗證機構名稱",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["原因", "驗證機構"]
                            }
                        },
                        {
                            "condition": "是",
                            "description": "接續上題, 如「是」，請提供上述事項的通知文件及有關已修正改善的書面確認函",
                            "type": "oeq",
                            "format": {
                                "multiple": false,
                                "fields": ["上傳檔案:file"]
                            }
                        }
                    ]
                },
            ]
        }
    ]
}

export default applicantOrganicCertificationHistoryQuestionnaire;